var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project)?_c('div',{staticClass:"project"},[_c('project-avatar',{attrs:{"project":_vm.project}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.project.name))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }